import { post, get } from '@integec/fetch-task'

const wrapInArray = req => (Array.isArray(req) ? req : [req])
export const getJobs = targetInfo => get(targetInfo, 'scheduler/jobs')
export const getTriggers = targetInfo => get(targetInfo, 'scheduler/triggers')
export const getApps = targetInfo => get(targetInfo, 'scheduler/apps')
export const saveJobs = targetInfo => request =>
  post(targetInfo, 'scheduler/jobs')(wrapInArray(request))
export const saveApps = targetInfo => request =>
  post(targetInfo, 'scheduler/apps')(wrapInArray(request))
export const saveTriggers = targetInfo => request =>
  post(targetInfo, 'scheduler/triggers')(wrapInArray(request))
export const triggerJobs = targetInfo => request =>
  post(targetInfo, 'scheduler/trigger-jobs')(wrapInArray(request))
